import { forIn } from "lodash";
import { LANGUAGE_TEXT } from "../../../../constants";

export const findTandcQuestions = (tcQuestions, accountState) => {
   let tandcCheckboxLabel =
      accountState?.conditionSpecificBehaviors?.translateText &&
      accountState?.storeInfo?.languageCode
         ? LANGUAGE_TEXT[accountState?.storeInfo?.languageCode]
              ?.terms_and_condition
         : "I have read, understood and agree to the";
   if (tcQuestions.length === 0) {
      tandcCheckboxLabel = "";
   } else if (tcQuestions.length === 1) {
      tandcCheckboxLabel = `${tandcCheckboxLabel} <strong>${
         tcQuestions[0].label + "."
      }</strong>`;
   } else {
      tcQuestions.forEach((tandcQuestion) => {
         if (tandcQuestion === tcQuestions[tcQuestions.length - 1]) {
            tandcCheckboxLabel = `${tandcCheckboxLabel} and <strong>${tandcQuestion.label}</strong>`;
         } else if (tandcQuestion === tcQuestions[tcQuestions.length - 2]) {
            tandcCheckboxLabel = `${tandcCheckboxLabel} <strong>${tandcQuestion.label}</strong>`;
         } else {
            tandcCheckboxLabel = `${tandcCheckboxLabel} <strong>${tandcQuestion.label}</strong>,`;
         }
      });
   }
   return tandcCheckboxLabel;
};

export const tandcQuestions = (questions) => {
   return questions.filter(
      (question) =>
         question.field.type === "tandc" &&
         question.label !== "" &&
         question.label !== null &&
         question.content !== "" &&
         question.content !== null
   );
};

export const checkedTandcValue = (checkedAnswers) => {
   let newCheckedAnswers = [];
   forIn(checkedAnswers, function (value) {
      if (value.type === "tandc") {
         newCheckedAnswers.push(value);
      }
   });
   return newCheckedAnswers.length !== 0
      ? newCheckedAnswers.every((answer) => answer.value)
      : false;
};
